import type { AppEntryContext } from '@core/entities/AppEntryContext';

export type AppEntryGatewayErrorCode = 'offline' | 'session-required' | 'request-failed';

export class AppEntryGatewayError extends Error {
  public constructor(
    public readonly code: AppEntryGatewayErrorCode,
    message: string
  ) {
    super(message);
    this.name = 'AppEntryGatewayError';
  }
}

export interface AppEntryContextGateway {
  getContext(): Promise<AppEntryContext>;
}